import React, { useState, useRef, useEffect } from 'react';
import { cloneDeep } from 'lodash';

import { useOutsideClick } from '../../../utils/custom-hooks';
import { Search } from '../../ui/search';
import Product from '../../publisher/trends/cart-explorer/product';

import './styles/product-dropdown.scss';

const ProductDropdown = ({
  setSearchQuery,
  searchQuery,
  placeholder,
  results,
  setProducts,
  creationType,
  selectedProducts,
  setSelectedProducts,
}) => {
  const dropdown = useRef(false);

  const [options, setOptions] = useState(results);
  const [selectAll, setSelectAll] = useState(false);
  const [open, setOpen] = useState(false);

  const confirmTxt =
    creationType === 'manual'
      ? `Add Products (${options && options.filter(option => option.selected).length})`
      : `Add "${searchQuery}" to Automated Collection`;

  useOutsideClick(dropdown, () => setOpen(false));

  useEffect(() => setOptions(results), [open]);

  useEffect(() => {
    setOptions(results);
    setOpen(true);
  }, [results]);

  function changeAll() {
    const newOptions = cloneDeep(options);
    newOptions.map(option => (option.selected = !selectAll));
    setOptions(newOptions);
    setProducts(newOptions);
    setSelectAll(!selectAll);
  }

  function selectOption(index) {
    const newOptions = cloneDeep(options);
    newOptions[index].selected = !newOptions[index].selected;
    setOptions(newOptions);
    setProducts(newOptions);
  }

  function confirm(e) {
    e.stopPropagation();
    setOpen(false);
    setSelectedProducts([...selectedProducts, ...options.filter(option => option.selected)]);
  }

  const menu =
    open && options && options.length ? (
      <div className="dropdown-menu">
        <h2>{options.length} Results</h2>
        <div className="headers">
          <span className={`checkbox ${selectAll ? 'selected' : ''}`} onClick={changeAll} />
          <div className="text-headers">
            <div className="product-label">Product</div>
            <div>Details</div>
          </div>
        </div>
        <div className="options">
          {options.map((result, index) => (
            <li className="dropdown-item" key={index} onClick={() => selectOption(index)}>
              <span className={`checkbox ${result.selected ? 'selected' : ''}`} />
              <Product product={result} type="collections" />
            </li>
          ))}
        </div>
        <button className="confirm-btn" onClick={e => confirm(e)}>
          {confirmTxt}
        </button>
      </div>
    ) : null;

  return (
    <div
      className="collections-product-dropdown"
      ref={node => (dropdown.current = node)}
      onClick={() => setOpen(true)}
    >
      <Search onSearch={setSearchQuery} placeholder={placeholder} />
      {menu}
    </div>
  );
};

export default ProductDropdown;
